/**
 * @file: useTaskResource.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
import { useTaskContext } from '@euler/app/flows/task/functions/TaskContext';
import { usePersistFn, useRefreshableAsyncResource } from '@euler/utils/hooks';

export const useAsyncTaskResource = <T>(params: {
  resourceId: (taskNo: string) => string;
  fetch: (taskNo: string) => Promise<T>;
}) => {
  const { resourceId, fetch } = params;
  const { taskNo } = useTaskContext();
  const factory = usePersistFn(() => fetch(taskNo));
  return useRefreshableAsyncResource(factory, resourceId(taskNo));
};
